import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getLoggedinUser } from "../../utils/StorageManager";

const TrialCountdown = () => {
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isTrialUser, setIsTrialUser] = useState(false);

  useEffect(() => {
    // Check if user is a trial user
    const authUser = getLoggedinUser() || {};
    
    if (authUser.user_free && authUser.user_freeType === "trial" && authUser.user_billingCycleEnd) {
      setIsTrialUser(true);
      
      // Calculate time remaining
      const calculateTimeRemaining = () => {
        const endDate = new Date(authUser.user_billingCycleEnd);
        const now = new Date();
        const diff = endDate - now;

        if (diff <= 0) {
          setTimeRemaining({ expired: true, days: 0 });
          return;
        }

        const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

        setTimeRemaining({ days });
      };

      calculateTimeRemaining();
      const interval = setInterval(calculateTimeRemaining, 1000);

      return () => clearInterval(interval);
    }
  }, []);

  if (!isTrialUser || !timeRemaining) {
    return null;
  }

  if (timeRemaining.expired) {
    return (
      <div className="ms-2 header-item d-none d-sm-flex" style={{ marginRight: '2rem' }}>
        <Link 
          to="/billing" 
          className="btn btn-topbar btn-ghost-danger rounded-pill py-2"
          style={{ whiteSpace: 'nowrap', width: 'auto', paddingLeft: '1rem', paddingRight: '1rem' }}
        >
          <i className="ri-time-line me-2 align-middle fs-18"></i>
          <span className="fw-semibold fs-14">Trial: 0 days</span>
        </Link>
      </div>
    );
  }

  const buttonColorClass = timeRemaining.days === 0 ? "btn-ghost-danger" : "btn-ghost-warning";

  return (
    <div className="ms-2 header-item d-none d-sm-flex" style={{ marginRight: '2rem' }}>
      <Link
        to="/billing"
        className={`btn btn-topbar ${buttonColorClass} rounded-pill py-2`}
        style={{ whiteSpace: 'nowrap', width: 'auto', paddingLeft: '1rem', paddingRight: '1rem' }}
      >
        <i className="ri-time-line me-2 align-middle fs-18"></i>
        <span className="fw-semibold fs-14">
          Trial: {timeRemaining.days} {timeRemaining.days === 1 ? 'day' : 'days'}
        </span>
      </Link>
    </div>
  );
};

export default TrialCountdown;